// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__1vqS6","slick-next":"CustomSlider_slick-next__2Zz46"};